export default __webpack_public_path__ + "static/media/Liz_Coalts_AHV_In_Moms_We_Trust.09741d77.jpg";